import axiosInstance from "./axiosInstance";

export const getAllPlanTypes = async () => {
  try {
    const response = await axiosInstance.get("/public/plan", {
      headers: { authType: "PreLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch plan types");
  }
};

export const getPlanTypeById = async (id) => {
  try {
    const response = await axiosInstance.get(`/planfetch/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch plan type");
  }
};

export const createPlanType = async (formData) => {
  try {
    const response = await axiosInstance.post("/plan", formData, {
      headers: {
        "Content-Type": "application/json",
        authType: "PostLogin",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to create plan type");
  }
};

export const updatePlanType = async (id, formData) => {
  try {
    const response = await axiosInstance.put(`/plan/${id}`, formData, {
      headers: {
        "Content-Type": "application/json",
        authType: "PostLogin",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to update plan type");
  }
};

export const deletePlanType = async (id) => {
  try {
    const response = await axiosInstance.delete(`/plandel/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to delete plan type");
  }
};